import { Auth } from 'aws-amplify';
import fileSaver from 'file-saver';
import config from '../../config';

const myfetch = (url: string, options: any = {}): ReturnType<typeof fetch> =>
  Auth.currentSession().then((u: any) => {
    const authorization = `Bearer ${u.getAccessToken().jwtToken}`;
    const headers = { ...(options?.headers || {}), authorization };

    if (typeof document !== 'undefined') {
      const hostname = window.location.hostname;
      const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
      const isSecureContext = window.location.protocol === 'https:';
      const cookieParts = [`user_token=${encodeURIComponent(authorization)}`, 'Path=/'];

      if (!isLocalhost) {
        cookieParts.push('Domain=.mktmediastats.com');
      }

      if (isSecureContext && !isLocalhost) {
        cookieParts.push('Secure');
        cookieParts.push('SameSite=None');
      } else {
        cookieParts.push('SameSite=Lax');
      }

      document.cookie = cookieParts.join('; ');
    }

    return fetch(url, { ...options, headers }).then((x: Response) => {
      if (x.status !== 200) {
        const isNotFound = x.status === 404;
        const errorMessage = isNotFound ? 'Data is currently not available' : x.statusText + ' (' + x.status + ' code)';
        return Promise.reject(new Error(errorMessage));
      }
      return x;
    });
  });

export const api = (url: string): any => myfetch(`${config.api.baseUrl}/${url}`).then(r => r.json());

export const text = (url: string): any => myfetch(`${config.api.baseUrl}/${url}`).then(r => r.text());

export const download = async (url: string, fileName: string): Promise<any> => {
  const r = await myfetch(`${config.api.baseUrl}/${url}`);
  const data = await r.blob();
  fileSaver.saveAs(data, fileName);
};

export const downloadMatrix = async (url: string): Promise<void> => {
  const r = await myfetch(`${config.api.baseUrl}/${url}`);
  const fileUrl = await r.text();
  window.location.href = fileUrl;
};
